import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Forget from "../../assets/forgetPass.png";
import apiKey from "../../config/apiKey";
import logo from "../../assets/logo.png";
import { NavLink, useNavigate } from "react-router-dom";
import { RxArrowLeft } from "react-icons/rx";

const Forgetpassword = () => {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false); // Add isLoading state
  const [isEmailSent, setIsEmailSent] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(0);

  const navigate = useNavigate(); // Hook to navigate programmatically

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // setIsLoading(true); // Set loading to true on form submit
    try {
      await axios
        .post(`${apiKey}/api/edolutions/resetpasswordemail`, {
          email,
        })
        .then((res) => {
          toast.success("Reset link sent successfully!", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            style: {
              backgroundColor: "#4FD1C5", // Customize background color
              color: "#fff", // Customize text color
            },
          });
          setIsEmailSent(true)
          setSecondsLeft(30);
        })
        .catch((err) => {
          toast.error("Reset link couldn't be sent.", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        })
        .finally(() => {
          setIsLoading(false);
        });
      // navigate("/admin/home");
    } catch (error) {
      toast
        .error("Failed to send reset link. Please try again.", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        })
        .finally(() => {
          setIsLoading(false); // Reset loading state after the request completes
        });
    }
  };

  useEffect(() => {
    if (secondsLeft > 0) {
      const timer = setTimeout(() => {
        setSecondsLeft(secondsLeft - 1);
      }, 1000);

      // Clean up the timer on unmount or when secondsLeft changes
      return () => clearTimeout(timer);
    }
  }, [secondsLeft]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "linear-gradient(160deg, #FFF8F2 0%, #FFE9D6 45%, #FFD9BF 100%)" }}>
      <div className="w-full max-w-md mx-4">
        <div className="bg-white rounded-3xl shadow-xl p-8">
          <div className="text-center mb-6">
            <button onClick={() => navigate(-1)} className="text-sm text-gray-500 hover:text-[#EE5F2B] font-semibold mb-4 inline-block">
              ← Back
            </button>
            <h1 className="text-2xl font-bold text-gray-800" style={{ fontFamily: "'Fredoka',sans-serif" }}>
              <span className="text-[#EE5F2B]">Cabil</span>
            </h1>
            <h2 className="text-xl font-bold text-gray-800 mt-3">Forgot Password</h2>
            {!isEmailSent && (
              <p className="text-sm text-gray-500 mt-1">Enter your email and we'll send you a reset link.</p>
            )}
          </div>

          {!isEmailSent ? (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-1">Email Address</label>
                <input
                  className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl outline-none focus:border-[#EE5F2B] focus:ring-1 focus:ring-[#EE5F2B] transition"
                  type="email"
                  placeholder="you@example.com"
                  value={email}
                  onChange={handleEmailChange}
                  required
                />
              </div>
              <button type="submit" disabled={isLoading}
                className="w-full bg-[#EE5F2B] hover:bg-orange-600 text-white font-bold py-3 rounded-xl transition shadow-md hover:shadow-lg text-lg disabled:opacity-50">
                {isLoading ? "Sending..." : "Send Reset Link"}
              </button>
            </form>
          ) : (
            <div className="text-center py-4">
              <div className="text-5xl mb-4">📧</div>
              <p className="text-gray-700 font-medium mb-2">Reset link sent!</p>
              <p className="text-sm text-gray-500 mb-4">
                We've sent a password reset link to <b className="text-gray-800">{email}</b>.<br />
                Check your inbox (and spam folder).
              </p>
              {secondsLeft === 0 ? (
                <button onClick={handleSubmit} className="text-[#EE5F2B] font-semibold hover:underline">
                  Resend link
                </button>
              ) : (
                <span className="text-gray-400 text-sm">Resend in {secondsLeft}s</span>
              )}
            </div>
          )}

          <p className="text-center text-sm text-gray-500 mt-4">
            Remember your password?{" "}
            <a href="/login" className="text-[#EE5F2B] font-semibold">Sign in</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Forgetpassword;
